import { createContext } from "react";

export const SportsCampsContext = createContext({
	dictionaryWords: [],
});
